import React, { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Typography, IconButton } from "@mui/material";
import ItemsList from "./ItemsList";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Components
import Spinner from "../layout/Spinner";

//Icons
import { ReactComponent as PlusIcon } from "../../assets/icons/svg/plus-solid.svg";

//Actions
import { openAddItemModal, fetchLocationItems } from "../../actions/pantry";

const PantrySection = ({ location, title, pantry: { locationItems }, openAddItemModal, fetchLocationItems }) => {
  const locationId = location._id;
  const pantryId = location.pantry;
  const section = locationItems[locationId] || {};
  const { loading, error, data = [] } = section;

  const handleAddToSection = () => {
    openAddItemModal({ type: "initial", stage: "location", location: locationId, pantry: pantryId });
  };

  return (
    <div className="border-separator border-y md:border md:rounded-lg md:shadow-sm bg-background">
      <div className="bg-background p-4 pb-0 md:p-6 md:pt-4 md:pb-0 md:rounded-t-lg">
        <div className="flex flex-row items-center w-full justify-between">
          <Typography variant="h6" className="font-normal mb-2">
            {title}
          </Typography>
          <div>
            <IconButton className="bg-neutral-100 hover:bg-neutral-200" onClick={handleAddToSection}>
              <PlusIcon className="h-3 w-auto fill-primaryText" />
            </IconButton>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 pt-0 md:pt-0">
        {loading ? (
          <div>
            <Spinner />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <div id={`pantry-section-scroll-${locationId}`}>
            <InfiniteScroll
              dataLength={data.length}
              next={() => fetchLocationItems(locationId, { offset: data.length, limit: 20 })}
              hasMore={!!section.hasMore}
              loader={<Typography className="text-secondaryText">Loading...</Typography>}
              scrollableTarget={`pantry-section-scroll-${locationId}`}
            >
              <ItemsList items={data} location={location} loading={loading} error={error} />
            </InfiniteScroll>
          </div>
        )}
      </div>
    </div>
  );
};

PantrySection.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  pantry: PropTypes.object.isRequired,
  openAddItemModal: PropTypes.func.isRequired,
  fetchLocationItems: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps, { openAddItemModal, fetchLocationItems })(PantrySection);
